import { useParams } from "react-router-dom";
import { useImmer } from "use-immer";
import {
  getBundleProductsApi,
  updateBundleProductsApi,
} from "../api/ProductApi";
import { errorMessage, successMessage } from "../../../utils";
import React from "react";

export const useBundleProducts = () => {
  const { id } = useParams();
  const [state, setState] = useImmer({
    loading: true,
    bundleProducts: [],
  });

  const getBundleProducts = async (productId) => {
    triggerTableLoading(true);
    try {
      const response = await getBundleProductsApi(productId);
      const { success, message, data } = response;
      if (success) {
        setState((draft) => {
          draft.bundleProducts = formatBundleProducts(data);
        });
      } else {
        errorMessage(message);
      }
    } catch (error) {
      const message =
        error.response?.data?.message ?? "Failed to fetch bundle products";
      errorMessage(message);
    } finally {
      triggerTableLoading(false);
    }
  };

  const updateBundleProducts = async (productId, payload) => {
    try {
      const response = await updateBundleProductsApi(productId, payload);
      const { success, message, data } = response;
      if (success) {
        successMessage(message);

        setState((draft) => {
          draft.bundleProducts = formatBundleProducts(data);
        });
      } else {
        errorMessage(message);
      }
    } catch (error) {
      const message =
        error.response?.data?.message ?? "Failed to sort bundle products";
      errorMessage(message);
    }
  };

  //   ================================================================== UTIL FUNCTIONS ===================================================================
  const triggerTableLoading = (loading) => {
    setState((draft) => {
      draft.loading = loading;
    });
  };

  const formatBundleProducts = (products) => {
    return products.map(({ product_id: id, display_order, bundle_name }) => ({
      id,
      display_order,
      bundle_name,
    }));
  };

  const onBundleProductsOrderChange = async (newOrder) => {
    setState((draft) => {
      draft.bundleProducts = newOrder;
    });

    await updateBundleProducts(id, {
      bundle_product_id: newOrder.map(
        ({ id: product_id, display_order }, index) => ({
          product_id,
          display_order: index + 1,
        })
      ),
    });
  };

  React.useEffect(() => {
    getBundleProducts(id);
  }, []);

  return { state, onBundleProductsOrderChange };
};
